export default __webpack_public_path__ + "assets/Pencil.8263.svg";